import React from 'react';
import { Container, Typography, Box, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const VideoMonetization: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <Box sx={{ minHeight: '100vh' }}>
      <Container maxWidth="md" sx={{ py: 8 }}>
        <Button onClick={() => navigate('/blog')} sx={{ mb: 3, textTransform: 'none' }}>
          {t('blog.backToBlog')}
        </Button>
        <Typography variant="overline" color="primary" sx={{ fontWeight: 600 }}>
          Monetization · May 2026
        </Typography>
        <Typography variant="h3" component="h1" sx={{ my: 2, fontWeight: 700 }}>
          Video Monetization on IndeeClips — Earn from Your Content
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ mb: 4, lineHeight: 1.85 }}>
          Learn how creators can earn revenue from their videos on IndeeClips through our monetization program.
        </Typography>

        <Typography variant="h5" sx={{ mt: 5, mb: 2, fontWeight: 700 }}>
          How Ads Work
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ mb: 3, lineHeight: 1.85 }}>
          IndeeClips displays ads before (pre-roll) and during (mid-roll) your videos. You earn revenue based on the
          number of views and ad interactions on your content.
        </Typography>

        <Typography variant="h5" sx={{ mt: 5, mb: 2, fontWeight: 700 }}>
          Eligibility Requirements
        </Typography>
        <Box component="ul" sx={{ '& li': { mb: 1, color: 'text.secondary', lineHeight: 1.85 } }}>
          <li>Minimum 1,000 subscribers on your channel</li>
          <li>At least 10,000 total video views</li>
          <li>Minimum of 10 videos uploaded on your channel</li>
          <li>Channel must be in good standing with no policy violations</li>
        </Box>

        <Typography variant="h5" sx={{ mt: 5, mb: 2, fontWeight: 700 }}>
          Payment Details
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ mb: 2, lineHeight: 1.85 }}>
          Payments are processed monthly via bank transfer or UPI. Minimum payout threshold is ₹500. Revenue reports
          are available in your creator dashboard.
        </Typography>

        <Typography variant="body1" color="text.secondary" sx={{ mt: 4, lineHeight: 1.85 }}>
          Monetization queries:{' '}
          <Typography
            component="a"
            href="mailto:contact@indeeclips.com"
            sx={{ color: 'primary.main', textDecoration: 'none', '&:hover': { textDecoration: 'underline' } }}
          >
            contact@indeeclips.com
          </Typography>
        </Typography>
      </Container>
    </Box>
  );
};

export default VideoMonetization;
